import Button from 'components/button';
import Markdown from 'components/markdown';
import { useConfig } from 'config';
import { ISectionSubscriptionFields } from 'global';
import useIsClient from 'hooks/common/use-is-client';
import RibbonText from 'modules/content-cms/components/ribbon-text';
import renderDocument from 'modules/content-cms/util/render-document';
import Link from 'next/link';
import React from 'react';
import { PopupButton } from 'react-calendly';
import ContentContainer from '../components/content-container';
import Image from '../components/image';
import Title from '../components/title';

const Subscription: React.FC<ISectionSubscriptionFields> = ({
  title,
  backgroundColor,
  text,
  image,
  imageLink,
  buttonLink,
  buttonText,
  richTitle,
}) => {
  const { calendlyUrl } = useConfig();
  const renderImage = () => {
    if (imageLink) {
      return (
        <a href={imageLink}>
          <Image {...image} className="max-w-auto h-auto rounded-full" />
        </a>
      );
    } else {
      return <Image {...image} className="h-auto max-w-full rounded-full" />;
    }
  };

  const { isClient } = useIsClient();

  let rootElement: null | HTMLElement = null;
  if (typeof document !== 'undefined') {
    rootElement = document.getElementById('__next');
  }

  return (
    (<ContentContainer backgroundColor={backgroundColor}>
      {richTitle ? (
        <RibbonText text={richTitle} />
      ) : title ? (
        <Title>{title}</Title>
      ) : null}
      <div className="items-center md:flex">
        <div className="flex justify-center md:w-1/2 md:pr-10">
          {renderImage()}
        </div>
        <div className="pt-10 md:w-1/2 md:pt-0">
          <Markdown>{text && renderDocument(text)}</Markdown>
        </div>
      </div>
      {buttonLink && buttonText && (
        <div className="flex justify-center pt-4 text-center">
          {buttonText === 'TERMIN VEREINBAREN' && rootElement && isClient ? (
            // Calendly termin pop-up for Beratung Page
            (<>
              <Button>
                <PopupButton
                  rootElement={rootElement}
                  className="text-md font-black uppercase tracking-wide"
                  text={buttonText}
                  url={calendlyUrl || ''}
                />
              </Button>
            </>)
          ) : (
            <Link href={buttonLink} passHref legacyBehavior>
              <Button>{buttonText}</Button>
            </Link>
          )}
        </div>
      )}
    </ContentContainer>)
  );
};

export default Subscription;
